import { Button } from 'reactstrap';
import { CampaignContext } from '~/context/campaign';
import { IPhotoInfo } from '~/types/campaign';
import { renderIcon } from '~/shared/components/icons';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import defaultProfileImg from '~/shared/img/HHLDefault-01.jpg';

export const PhotoCard = ({ hideSidebar }: any) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [{ campaign }, campaignDispatch] = useContext(CampaignContext);
    const [patientInfo, setPatientInfo] = useState(null);
    const [photoInfo, setPhotoInfo] = useState<IPhotoInfo>();
    const history = useHistory();

    useEffect(() => {
        if (campaign) {
            const { campaignDetail, photoInfo, patient } = campaign;
            setLoading(true);
            setPhotoInfo(campaign.campaignPhotoInfo);
            setPatientInfo(patient);
        }
    }, [campaign]);

    if (!photoInfo) {
        return <div />;
    }

    const person = patientInfo?.person;
    const campaignTitle = campaign?.campaignEditInfo?.campaign_title;
    const displayName = person
        ? `${person.first_name} ${person.last_name}`
        : campaignTitle || '';

    const showPhoto = () => {
        return (
            <div className='profile-photo-wrap'>
                <div className='profile-photo'>
                    <img
                        src={
                            photoInfo.photo_thumb_url ||
                            photoInfo.photo_url ||
                            defaultProfileImg
                        }
                        alt={displayName}
                    />
                </div>
                {person && (
                    <Button
                        color='link'
                        onClick={() => {
                            history.push('/patient/edit');
                            hideSidebar();
                        }}
                    >
                        {renderIcon('edit')}
                    </Button>
                )}
            </div>
        );
    };

    return (
        <div className='profile-info'>
            {showPhoto()}
            <div>
                {displayName && (
                    <div className='profile-name'>{displayName}</div>
                )}
                {person && (
                    <div className='profile-location'>
                        {`${person.city || ''} ${person.state || ''}`}
                    </div>
                )}
                <div className='profile-fund'>{photoInfo.fund_name}</div>
            </div>
            {person && (
                <Button
                    color='link'
                    onClick={() => {
                        history.push('/patient/edit');
                        hideSidebar();
                    }}
                >
                    {renderIcon('edit')}
                </Button>
            )}
        </div>
    );
};
